<template>
	<NavSidebarLayout
		class="router-view-layout"
		:show-left-sidebar="showLeftSidebar"
		:scrollable="false"
	>
		<main>
			<router-view
				:show-mobile-menu-icon="showMobileMenuIcon"
				:screen-width="screenWidth"
				v-bind="$attrs"
				@mobileMenuIconClicked="onMobileMenuIconClicked"
			/>
		</main>
	</NavSidebarLayout>
</template>

<script>
import ScreenSizeDetector from "screen-size-detector";

/**
 * RouterViewLayout
 * Layout that includes the nav sidebar, and allows child components to take up the
 * remaining screen space. Useful if you need a "full page + sidebar" layout.
 *
 * Configure as a top-level route component and be sure to propagate props.
 *
 * Assumes the route is protected by AuthGuard middleware, which loads the injected
 * userProfile.
 */
export default {
	name: "RouterViewLayout",
	inject: [ "userProfile", ],
	data() {
		return {
			screenWidth: window.innerWidth,
		};
	},
	props: {
		showLeftSidebar: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		showMobileMenuIcon() {
			return this.$foundation().config.permitMobileMenu;
		},
	},
	methods: {
		onMobileMenuIconClicked( e ) {
			e.preventDefault();
			e.stopPropagation();
			this.$foundation().sidebar.open();
		},
	},
	created() {
		this.screen = new ScreenSizeDetector( {
			onWidthChange: () => {
				this.screenWidth = this.screen.width;
			},
		} );
	},
	unmounted() {
		this.screen.removeMainCallback( "widthchange" );
		this.screen = undefined;
	},
};
</script>

<style lang="scss">
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	height: 100%;
}
</style>
